import React from 'react';
import YoutubePlayer from '../../common/YoutubePlayer';
import CloseModalButton from '../../common/Modal/Buttons/CloseModalButton';

export default function Modal(props) {
	return (
		<div className='project-popup '>
			<h1 className='project-popup__title '>Traveling online store</h1>
			<p className='project-popup__description '>
				This web app allows users to find an optimal tour in any country in the
				world, and book it, right on the website. It includes a large selection of
				hotels and tours to them. The best option is easy to find using a convenient
				and clear set of filters. The database can be huge, so the data is loaded via
				AJAX. Besides the core platform logic, I developed a special admin panel that
				allows managing all information in the online store (hotels, tours, common
				info). The visual part of the project was made by me, using just a layout and
				my sense of beauty :)
			</p>
			<div className='project-popup__about '>
				<p>
					<span className='span-title '>Stack:</span>
					<span className='span-description '>
						PHP ( Laravel ), MySQL, Design, HTML, CSS, responsive web, Bootstrap,
						Javascript, JQuery, Handlebars, Bitrix 24, Tinkoff API etc.
					</span>
				</p>
			</div>
			<div className='project-popup__videos'>
				<YoutubePlayer
					src='https://www.youtube.com/embed/q-6rQuJY4_w'
					title='Traveling online store'
				/>
			</div>
			<div className='project-popup__buttons '>
				<CloseModalButton onClose={props.closeModal} />
			</div>
		</div>
	);
}
